document.addEventListener('DOMContentLoaded', () => {

    // HEADER / FOOTER ANNOUNCEMENTS

      function initMobileAnnouncements() {
            // Find ALL announcement containers
            const containers = document.querySelectorAll('.split-announcements--container');
            
            containers.forEach((container, containerIndex) => {
                const blocks = container.querySelectorAll('.split-announcements--block');
                //console.log(`Container ${containerIndex + 1}: Found ${blocks.length} announcement blocks`);
                
                let currentIndex = 0;
                let intervalId;

                function isMobile() {
                    return window.innerWidth < 768;
                }

                function showNextAnnouncement() {
                    if (!isMobile()) return;

                    // Calculate next index
                    const nextIndex = (currentIndex + 1) % blocks.length;
                    
                    // Immediately start showing the next announcement
                    blocks[nextIndex].classList.add('active');
                    
                    // Hide the current one and update currentIndex immediately
                    blocks[currentIndex].classList.remove('active');
                    currentIndex = nextIndex;
                }

                function startRotation() {
                    if (isMobile() && !intervalId) {
                        // Reset all blocks first
                        blocks.forEach(block => block.classList.remove('active'));
                        
                        // Show first announcement immediately
                        blocks[0].classList.add('active');
                        currentIndex = 0;
                        
                        // Start rotation every 3 seconds
                        // Add a slight offset for each container to prevent synchronization
                        const delay = containerIndex * 1000; // 1 second offset per container
                        setTimeout(() => {
                            intervalId = setInterval(showNextAnnouncement, 3000);
                        }, delay);
                    }
                }

                function stopRotation() {
                    if (intervalId) {
                        clearInterval(intervalId);
                        intervalId = null;
                    }
                    
                    // Reset all blocks to visible on desktop
                    if (!isMobile()) {
                        blocks.forEach(block => {
                            block.classList.remove('active');
                        });
                    }
                }

                function handleResize() {
                    if (isMobile()) {
                        startRotation();
                    } else {
                        stopRotation();
                    }
                }

                // Initialize on page load
                handleResize();

                // Listen for window resize
                window.addEventListener('resize', handleResize);

                // Optional: Pause rotation on hover (mobile)
                container.addEventListener('mouseenter', () => {
                    if (isMobile() && intervalId) {
                        clearInterval(intervalId);
                        intervalId = null;
                    }
                });

                container.addEventListener('mouseleave', () => {
                    if (isMobile() && !intervalId) {
                        intervalId = setInterval(showNextAnnouncement, 3000);
                    }
                });
            });
        }

        // Initialize when DOM is ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initMobileAnnouncements);
        } else {
            initMobileAnnouncements();
        }


    // X-MENU OVERLAY
    // Shown and hidden with the menu itself, see X-MENU HOVER INTENT


    // SAMPLES


    // Samples popup functionality
    const samplesPopup = document.querySelector('.samples-popup');
    const samplesButtons = document.querySelectorAll('.cart--samples-select');
    const closeButton = document.querySelector('.samples-popup--close');

    // Track selected samples and choice mode
    let selectedSamples = [];
    let chooseForMeMode = false;

    // Initialize accordion toggle functionality
    initializeAccordionToggle();

    // Initialize state based on server-side cart attributes
    initializeCartState();

    // Initialize product card functionality
    
    // Function to initialize cart state from server-side attributes
    async function initializeCartState() {
        try {
            // Fetch cart to get current state from attributes
            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();
            
            const sampleChoices = cart.attributes && cart.attributes['Sample Choices'];
            const chooseForMe = cart.attributes && cart.attributes['Choose For Me'];
            
            // Set initial state based on cart attributes
            if (sampleChoices && sampleChoices.trim() !== '' && chooseForMe !== 'true') {
                chooseForMeMode = false;
                // selectedSamples will be populated by updateSelectedSamplesAccordion
            } else {
                chooseForMeMode = chooseForMe === 'true';
                selectedSamples = [];
            }
            
            // Update the accordion with current state
            await updateSelectedSamplesAccordion();
            
            console.log('Initialized cart state:', {
                chooseForMeMode,
                selectedSamples: selectedSamples.length,
                sampleChoices: sampleChoices || '',
                chooseForMe: chooseForMe || ''
            });
        } catch (error) {
            console.error('Error initializing cart state:', error);
            // Fallback to default state
            chooseForMeMode = false;
            selectedSamples = [];
        }
    }
    
    // Function to extract sample data from card
    function extractSampleData(card) {
        const img = card.querySelector('img');
        const vendor = card.querySelector('.sample-vendor')?.textContent.trim();
        const title = card.querySelector('.sample-title')?.textContent.trim();
        const scent = card.querySelector('.product-card--scent-family')?.textContent.trim();
        return {
            vendor: vendor,
            title: title,
            scent: scent,
            image: img ? img.src : null
        };
    }
    
    // Function to update selected samples accordion
    async function updateSelectedSamplesAccordion(forcedSampleChoices = null, forcedChooseForMe = null) {
        const accordion = document.getElementById('selected-samples-accordion');
        const samplesList = document.getElementById('selected-samples-list');
        const samplesCount = document.getElementById('selected-samples-count');

        const chooseForMeButton = document.querySelector('.cart--samples-choose-for-me');
        const selectSamplesButton = document.querySelector('.cart--samples-select:not(.cart--samples-choose-for-me)');

        if (!accordion || !samplesList || !samplesCount) {
            return; // Elements not found, likely not on cart page
        }

        try {
            let sampleChoices, chooseForMe;

            if (forcedSampleChoices !== null && forcedChooseForMe !== null) {
                // Use forced values instead of fetching from server
                sampleChoices = (Array.isArray(forcedSampleChoices) ? forcedSampleChoices.map(choice => choice.title.trim()).join('; ') : forcedSampleChoices);
                chooseForMe = forcedChooseForMe;
            } else {
                // Fetch current cart to get attributes
                const cartResponse = await fetch('/cart.js');
                const cart = await cartResponse.json();

                sampleChoices = cart.attributes && cart.attributes['Sample Choices'];
                chooseForMe = cart.attributes && cart.attributes['Choose For Me'];
            }
            
            // Check if we should show the accordion
            const shouldShowAccordion = sampleChoices && sampleChoices.trim() !== '' && chooseForMe !== 'true';
            
            if (shouldShowAccordion) {
                // Parse sample choices (semicolon-separated list)
                const sampleNames = sampleChoices.split(';').map(name => name.trim()).filter(name => name !== '');
                
                // Show accordion and update count
                accordion.style.display = 'block';
                samplesCount.textContent = sampleNames.length;
                
                // Get all available samples from popup to match against
                const availableSamples = getAllAvailableSamples();
                
                // Match cart attribute samples with available sample data
                const matchedSamples = sampleNames.map(sampleName => {
                    const matchedSample = availableSamples.find(sample => 
                        sample.title.toLowerCase().trim() === sampleName.toLowerCase().trim()
                    );
                    
                    if (matchedSample) {
                        return {
                            title: matchedSample.title,
                            vendor: matchedSample.vendor,
                            image: matchedSample.image
                        };
                    } else {
                        // Fallback for samples not found
                        return {
                            title: sampleName,
                            vendor: '',
                            image: null
                        };
                    }
                });
                
                // Populate accordion with matched samples
                samplesList.innerHTML = matchedSamples.map(sample => `
                    <div class="selected-sample-item">
                        <div class="selected-sample-details">
                        <div class="selected-sample-image-container">
                            ${sample.image ? `<img src="${sample.image}" alt="${sample.title}" class="selected-sample-image">` : ''}
                            </div>
                            <div class="selected-sample-info">
                                ${sample.vendor ? `<div class="selected-sample-vendor h6" data-item="small-text">${sample.vendor}</div>` : ''}
                                <div class="selected-sample-title h3" data-item="nav-text">${sample.title}</div>
                            </div>
                        </div>
                        <div class="selected-sample-price h5" data-item="nav-text">FREE</div>
                    </div>
                `).join('');
                
                // Update local selectedSamples array for consistency
                selectedSamples = matchedSamples.map(sample => ({
                    title: sample.title,
                    vendor: sample.vendor,
                    image: sample.image,
                    scent: '' // Not available from cart attributes
                }));
                chooseForMeMode = false;
                selectSamplesButton.classList.add('button--selected');
                chooseForMeButton.classList.remove('button--selected');


                matchedSamples.map(sample => {
                  let sampleCard = document.querySelector(`.sample-card[data-product-title="${sample.title}"]`);
                  if (sampleCard) {
                      sampleCard.classList.add('selected');
                      const button = sampleCard.querySelector('.sample-select-btn');
                      if (button) {
                          button.textContent = 'Selected';
                      }
                  }
                });

                selectSamplesButton.querySelector('span[data-content]').innerHTML = `${matchedSamples.length} Free Samples Selected`;
            } else {
                // Hide accordion and clear content
                accordion.style.display = 'none';
                samplesList.innerHTML = '';
                samplesCount.textContent = '0';
                selectedSamples = [];
                chooseForMeMode = chooseForMe === 'true';
                selectSamplesButton.querySelector('span[data-content]').innerHTML = `Select 3 Free Samples`;

                if (chooseForMeMode) {
                  chooseForMeButton.classList.add('button--selected');
                  selectSamplesButton.classList.remove('button--selected');
                }
            }
        } catch (error) {
            console.error('Error updating selected samples accordion:', error);
            // Fallback behavior
            accordion.style.display = 'none';
            samplesList.innerHTML = '';
            samplesCount.textContent = '0';

            selectedSamples = [];
            chooseForMeMode = false;
            selectSamplesButton.querySelector('span[data-content]').innerHTML = `Select 3 Free Samples`;
            selectSamplesButton.classList.remove('button--selected');
            chooseForMeButton.classList.remove('button--selected');
        }
    }
    
    // Function to get all available samples from the popup
    function getAllAvailableSamples() {
        const sampleCards = document.querySelectorAll('.sample-card');
        const samples = [];
        
        sampleCards.forEach(card => {
            const img = card.querySelector('.sample-image');
            const vendor = card.querySelector('.sample-vendor')?.textContent.trim();
            const title = card.querySelector('.sample-title')?.textContent.trim();
            const scent = card.querySelector('.product-card--scent-family')?.textContent.trim();
            
            if (title) {
                samples.push({
                    title: title,
                    vendor: vendor || '',
                    image: img ? img.src : null,
                    scent: scent || ''
                });
            }
        });
        
        return samples;
    }
    
    // Function to initialize accordion toggle functionality
    function initializeAccordionToggle() {
        const header = document.getElementById('selected-samples-header');
        const toggle = document.getElementById('selected-samples-toggle');
        const content = document.getElementById('selected-samples-content');
        
        if (header && toggle && content) {
            header.addEventListener('click', () => {
                const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
                
                if (isExpanded) {
                    content.style.display = 'none';
                    toggle.setAttribute('aria-expanded', 'false');
                    toggle.classList.remove('expanded');
                } else {
                    content.style.display = 'block';
                    toggle.setAttribute('aria-expanded', 'true');
                    toggle.classList.add('expanded');
                }
            });
        }
    }
    
    // Function to update confirm button state
    function updateConfirmButtonState() {
        let confirmButton = document.querySelector('.samples-popup--button.primary');
        if (!confirmButton) {
            confirmButton = document.querySelector('.samples-popup--button.secondary');
        }
        const selectedCount = document.querySelectorAll('.sample-card.selected').length;
        const maxSamples = parseInt(document.querySelector('[data-sample-quantity]')?.dataset.sampleQuantity) || 3;
        
        if (confirmButton) {
            if (selectedCount === maxSamples) {
                confirmButton.disabled = false;
                confirmButton.classList.remove('secondary');
                confirmButton.classList.add('primary');
            } else {
                confirmButton.disabled = true;
                confirmButton.classList.remove('primary');
                confirmButton.classList.add('secondary');
            }
        }
    }

    // Open popup when samples button is clicked
    samplesButtons.forEach(button => {
        button.addEventListener('click', async (e) => {
            e.preventDefault();
            
            // Check if this is the "Choose For Me" button
            if (button.classList.contains('cart--samples-choose-for-me')) {
                // Handle Choose For Me directly without opening popup
                await handleChooseForMeDirectly();
                return;
            } else {
                chooseForMeMode = false;
                // Clear any previous selections when opening for manual selection
                selectedSamples = [];
            }
            
            samplesPopup.classList.add('active');
            document.body.style.overflow = 'hidden';
            
            // Initialize popup functionality after opening
            initializeSamplesPopup();
        });
    });
    
    // Function to handle Choose For Me directly from main cart
    async function handleChooseForMeDirectly() {
        // Clear any previously selected samples
        selectedSamples = [];
        chooseForMeMode = true;
        
        let confirmButton = document.querySelector('.samples-popup--button.primary');
        if (!!confirmButton) {
          confirmButton.disabled = true;
          confirmButton.classList.remove('primary');
          confirmButton.classList.add('secondary');
        }

        // Clear visual selections in popup
        const sampleCards = document.querySelectorAll('.sample-card');
        sampleCards.forEach(card => {
            card.classList.remove('selected', 'disabled');
            const button = card.querySelector('.sample-select-btn');
            if (button) {
                button.textContent = 'Select Sample';
                button.disabled = false;
            }
        });
        
        // Update cart attributes using Shopify Cart API
        const attributes = {
            'Choose For Me': 'true',
            'Sample Choices': '' // Clear the manual selection attribute
        };

        samplesButtons.forEach(button => {
          button.classList.add('button--loading');
        });

        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                attributes: attributes
            })
        }).then(response => response.json())
          .then(async data => {
              console.log('Choose for me cart attributes updated:', attributes);

              // Hide accordion since it's choose for me mode
              await updateSelectedSamplesAccordion('', 'true');

              samplesButtons.forEach(button => {
                button.classList.remove('button--loading');
              });
          })
          .catch(error => {
              console.error('Error updating cart attributes:', error);
          });
    }

    function initializeSamplesPopup() {
        const sampleCards = document.querySelectorAll('.sample-card');
        const samplesPopup = document.querySelector('.samples-popup--content');
        
        // Mark popup as initialized and add data attributes to prevent duplicate listeners
        if (samplesPopup.hasAttribute('data-initialized')) {
            return;
        }
        samplesPopup.setAttribute('data-initialized', 'true');
        
        // Add data attributes to buttons to track their purpose
        const confirmButton = document.querySelector('.samples-popup--button.primary');
        const chooseForMeButton = document.querySelector('.samples-popup--button.secondary');
        
        if (confirmButton && !confirmButton.hasAttribute('data-action')) {
            confirmButton.setAttribute('data-action', 'confirm-samples');
        }
        if (chooseForMeButton && !chooseForMeButton.hasAttribute('data-action')) {
            chooseForMeButton.setAttribute('data-action', 'choose-for-me');
        }
        
        // Add data attributes to sample cards
        sampleCards.forEach(card => {
            if (!card.hasAttribute('data-sample-card')) {
                card.setAttribute('data-sample-card', 'true');
            }
        });
        
        // Initialize confirm button state (disabled by default)
        updateConfirmButtonState();
    }

    // Close popup
    const closePopup = () => {
        samplesPopup.classList.remove('active');
        document.body.style.overflow = '';
    };

    // Event delegation for all popup interactions
    document.addEventListener('click', async (e) => {
        // Handle close button
        if (e.target.classList.contains('samples-popup--close')) {
            closePopup();
            return;
        }

        // Handle overlay click to close popup
        if (e.target.classList.contains('samples-popup')) {
            closePopup();
            return;
        }

        // Handle sample card selection
        const sampleCard = e.target.closest('[data-sample-card]');
        if (sampleCard) {
            await handleSampleCardClick(sampleCard);
            return;
        }

        // Handle action buttons
        const actionButton = e.target.closest('[data-action]');
        if (actionButton) {
            const action = actionButton.getAttribute('data-action');
            if (action === 'confirm-samples') {
                await handleConfirmSamples();
            } else if (action === 'choose-for-me') {
                await handleChooseForMe();
            }
            return;
        }
    });

    // Handle sample card selection
    async function handleSampleCardClick(card) {
        const button = card.querySelector('.sample-select-btn');
        const isSelected = card.classList.contains('selected');
        
        // Toggle selection
        if (isSelected) {
            card.classList.remove('selected');
            button.textContent = 'Select Sample';
            
            // Remove from selectedSamples array
            const sampleData = extractSampleData(card);
            selectedSamples = selectedSamples.filter(sample => 
                sample.vendor !== sampleData.vendor || sample.title !== sampleData.title
            );
        } else {
            // Check selection limit (get from metaobject or default to 3)
            const maxSamples = parseInt(document.querySelector('[data-sample-quantity]')?.dataset.sampleQuantity) || 3;
            const selectedCount = document.querySelectorAll('.sample-card.selected').length;
            
            if (selectedCount >= maxSamples) {
                alert(`You can only select ${maxSamples} samples.`);
                return;
            }
            
            card.classList.add('selected');
            button.textContent = 'Selected';
            
            // Add to selectedSamples array
            selectedSamples.push(extractSampleData(card));
        }
        
        // Update the selected samples accordion
        //await updateSelectedSamplesAccordion(selectedSamples, false);
        
        // Update confirm button state
        updateConfirmButtonState();
        
        // Update available/disabled states
        updateCardStates();
    }

    // Handle choose for me functionality
    async function handleChooseForMe() {
        
        samplesButtons.forEach(button => {
          button.classList.add('button--loading');
        });
        closePopup();
        // Set choose for me mode
        chooseForMeMode = true;
        
        let confirmButton = document.querySelector('.samples-popup--button.primary');
        if (!!confirmButton) {
          confirmButton.disabled = true;
          confirmButton.classList.remove('primary');
          confirmButton.classList.add('secondary');
        }
        
        // Get sample quantity limit
        const maxSamples = parseInt(document.querySelector('[data-sample-quantity]')?.dataset.sampleQuantity) || 3;
        
        // Create array of all available samples
        const sampleCards = document.querySelectorAll('.sample-card');
        const availableSamples = Array.from(sampleCards);
        
        // Randomly select samples
        const shuffled = availableSamples.sort(() => 0.5 - Math.random());
        const selected = shuffled.slice(0, maxSamples);
        
        // Clear current selections and selected samples array
        selectedSamples = [];
        sampleCards.forEach(card => {
            card.classList.remove('selected', 'disabled');
            const button = card.querySelector('.sample-select-btn');
            button.textContent = 'Select Sample';
            button.disabled = false;
        });
        
        // Add selected samples to array for order processing
        selected.forEach(card => {
            selectedSamples.push(extractSampleData(card));
        });
        
        // Update cart attributes using Shopify Cart API
        const attributes = {
            'Choose For Me': 'true',
            'Sample Choices': '' // Clear the manual selection attribute
        };
        
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                attributes: attributes
            })
        }).then(response => response.json())
          .then(async data => {
              console.log('Choose for me cart attributes updated:', attributes);
              console.log('Choose for me samples:', selectedSamples);

              // Hide accordion since it's choose for me mode
              await updateSelectedSamplesAccordion('', 'true');

              // Close popup
              closePopup();
              samplesButtons.forEach(button => {
                button.classList.remove('button--loading');
              });
          })
          .catch(error => {
              console.error('Error updating cart attributes:', error);
              closePopup();
              samplesButtons.forEach(button => {
                button.classList.remove('button--loading');
              });
          });
    }

    // Handle confirm samples functionality
    async function handleConfirmSamples() {
        
        samplesButtons.forEach(button => {
          button.classList.add('button--loading');
        });
        closePopup();
        const selectedCards = Array.from(document.querySelectorAll('.sample-card.selected'));
        const maxSamples = parseInt(document.querySelector('[data-sample-quantity]')?.dataset.sampleQuantity) || 3;
        if (selectedCards.length === 0) {
            return;
        }

        // Ensure exact sample requirement is met (controlled by metaobject)
        if (selectedCards.length !== maxSamples) {
            return;
        }

        // Prepare sample data for cart attributes
        const sampleChoices = selectedCards.map(card => {
            const title = card.querySelector('.sample-title')?.textContent.trim();
            return title;
        }).join('; ');

        console.log('handleConfirmSamples called with:', {
            chooseForMeMode: chooseForMeMode,
            selectedCardsLength: selectedCards.length,
            sampleChoices: sampleChoices
        });

        // Since the user manually selected samples (we're in the confirm handler),
        // this should always be manual selection, not choose for me
        const attributes = {
            'Sample Choices': sampleChoices,
            'Choose For Me': '' // Always clear choose for me when manually confirming
        };


        // Update cart attributes
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                attributes: attributes
            })
        }).then(response => response.json())
          .then(async data => {
              console.log('Cart attributes updated:', attributes);

              // Always update accordion for manual confirmation since we set manual attributes
              await updateSelectedSamplesAccordion(sampleChoices, '');

              samplesButtons.forEach(button => {
                button.classList.remove('button--loading');
              });
              // Update local state to reflect manual selection
              chooseForMeMode = false;

              // Close popup
          })
          .catch(error => {
              console.error('Error updating cart attributes:', error);
              closePopup();
          });
    }

    // Update card states (enabled/disabled)
    function updateCardStates() {
        const sampleCards = document.querySelectorAll('.sample-card');
        const currentSelectedCount = document.querySelectorAll('.sample-card.selected').length;
        const maxSamples = parseInt(document.querySelector('[data-sample-quantity]')?.dataset.sampleQuantity) || 3;
        
        if (currentSelectedCount >= maxSamples) {
            // Disable unselected cards
            sampleCards.forEach(card => {
                if (!card.classList.contains('selected')) {
                    card.classList.add('disabled');
                    card.querySelector('.sample-select-btn').disabled = true;
                }
            });
        } else {
            // Re-enable all cards
            sampleCards.forEach(card => {
                card.classList.remove('disabled');
                card.querySelector('.sample-select-btn').disabled = false;
            });
        }
    }

    // Escape key to close popup
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && samplesPopup.classList.contains('active')) {
            closePopup();
        }
    });
    
    // Checkout fallback functionality
    const checkoutButton = document.querySelector('.cart--checkout-button');
    if (checkoutButton) {
        let isProcessingFallback = false;
        
        checkoutButton.addEventListener('click', (e) => {
            // Skip if we're already processing a fallback to avoid infinite loops
            if (isProcessingFallback) {
                return;
            }
            
            // Check if samples have been selected or choose for me is active
            if (!chooseForMeMode && selectedSamples.length === 0) {
                // Check if there are any cart attributes for samples
                fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => {
                        const hasChooseForMe = cart.attributes && cart.attributes['Choose For Me'];
                        const hasSampleChoices = cart.attributes && cart.attributes['Sample Choices'];
                        
                        // If no sample selection method is active, add choose for me as fallback
                        if (!hasChooseForMe && !hasSampleChoices) {
                            e.preventDefault();
                            isProcessingFallback = true;
                            
                            // Add choose for me cart attribute
                            fetch('/cart/update.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    attributes: {
                                        'Choose For Me': 'true'
                                    }
                                })
                            }).then(response => response.json())
                              .then(() => {
                                  console.log('Added choose for me fallback for checkout');
                                  // Submit the form to proceed with checkout
                                  checkoutButton.closest('form').submit();
                              })
                              .catch(error => {
                                  console.error('Error adding choose for me fallback:', error);
                                  // Proceed with checkout even if attribute update fails
                                  checkoutButton.closest('form').submit();
                              })
                              .finally(() => {
                                  isProcessingFallback = false;
                              });
                        }
                    })
                    .catch(error => {
                        console.error('Error checking cart attributes:', error);
                        // Proceed with checkout if we can't check cart state
                    });
            }
        });
    }


    // Function to check if cart has valid products and reset samples if needed
    const checkValidProductsAndResetSamples = async () => {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();

            const hasValidProducts = cart.items.some(item => {
                const productType = item.product_type;
                    const productTitle = item.product_title;

                    // Apply the same validation logic as in the Liquid template
                    return productType !== "Online Masterclass" &&
                           productType !== "Discovery Masterclass" &&
                           productTitle !== "Libertine Samples" &&
                           productType !== "In-Store Masterclass" &&
                           productType !== "event" &&
                           productType !== "Event" &&
                           productType !== "Gift Cards";
            });

            // Only reset if no valid products AND we currently have sample attributes
            const currentChooseForMe = cart.attributes && cart.attributes['Choose For Me'];
            const currentSampleChoices = cart.attributes && cart.attributes['Sample Choices'];
            const hasSampleAttributes = currentChooseForMe || (currentSampleChoices && currentSampleChoices.trim() !== '');

            if (!hasValidProducts) {
              samplesButtons.forEach(button => {
                  button.style.display = 'none';
              });
              
              if (hasSampleAttributes) {
                const attributes = {
                    'Choose For Me': '',
                    'Sample Choices': ''
                };

                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        attributes: attributes
                    })
                }).then(response => response.json())
                  .then(async () => {
                      console.log('Sample attributes reset - no valid products in cart');
                      // Update local state
                      selectedSamples = [];
                      chooseForMeMode = false;
                      await updateSelectedSamplesAccordion();
                  })
                  .catch(error => {
                      console.error('Error resetting sample attributes:', error);
                  });
              }
            }
        } catch (error) {
            console.error('Error fetching cart data:', error);
        }
    }

    window.addEventListener("theme:cart:drawer:updateHtml", async () => {
        if (window.location.pathname === '/cart') {
            await checkValidProductsAndResetSamples();
            // Reinitialize state without page reload to prevent losing current selections
            await initializeCartState();
        }
    });

    window.addEventListener("theme:cart:desktop:updateHtml", async () => {
        if (window.location.pathname === '/cart') {
            await checkValidProductsAndResetSamples();
            // Reinitialize state without page reload to prevent losing current selections
            await initializeCartState();
        }
    });

    window.addEventListener("theme:cart:mobile:updateHtml", async () => {
        if (window.location.pathname === '/cart') {
            await checkValidProductsAndResetSamples();
            // Reinitialize state without page reload to prevent losing current selections
            await initializeCartState();
        }
    });

    // Function to update variant based on selected options
    function updateProductCardVariant(card) {
        const options = card.querySelectorAll('.product-options--option');
        const addButton = card.querySelector('button.add[data-variant]');
        const priceElement = card.querySelector('button.add .price');

        if (!addButton) return;

        // Get selected options
        const selectedOptions = [];
        options.forEach(optionContainer => {
            const checkedRadio = optionContainer.querySelector('input[type="radio"]:checked');
            if (checkedRadio) {
                const variantId = checkedRadio.getAttribute('data-option-value-id');
                const price = checkedRadio.getAttribute('data-price');
                selectedOptions.push({ variantId, price });
            }
        });

        // Update button with the last selected variant (this assumes single option products)
        // For multi-option products, you'd need to find the variant that matches all selected options
        if (selectedOptions.length > 0) {
            const lastSelected = selectedOptions[selectedOptions.length - 1];
            if (lastSelected.variantId) {
                addButton.setAttribute('data-variant', lastSelected.variantId);
                addButton.disabled = false;

                if (priceElement && lastSelected.price) {
                    priceElement.textContent = lastSelected.price;
                }

            }
        }
    }
    
    window.updateProductCardVariant = updateProductCardVariant; // Expose function globally for testing
});

document.addEventListener('DOMContentLoaded', function() {
  //console.log('Afterpay updater loaded');
  
  // Watch the hidden variant input for changes
  const variantInput = document.querySelector('.product-buy-buttons--input[name="id"]');
  
  if (variantInput) {
    //console.log('Watching variant input, current value:', variantInput.value);
    
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'value') {
          const newVariantId = variantInput.value;
          //console.log('Variant changed to:', newVariantId);
          
          updateAfterpayWidget(newVariantId);
        }
      });
    });
    
    observer.observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });
  }
  
  function updateAfterpayWidget(variantId) {
    const squarePlacement = document.querySelector('square-placement');
    
    if (squarePlacement) {
      //console.log('Found square-placement element');
      
      // Get the current price from the price display element
      const priceElement = document.querySelector('.product-price--original');
      if (priceElement) {
        const priceText = priceElement.textContent || priceElement.innerText;
        const priceMatch = priceText.match(/[\d,]+\.?\d*/);
        
        if (priceMatch) {
          const price = parseFloat(priceMatch[0].replace(',', ''));
          //console.log('Updating Afterpay with price:', price);
          
          squarePlacement.setAttribute('data-amount', price.toString());
        } else {
          //console.log('Could not extract price from:', priceText);
        }
      } else {
        //console.log('Could not find price element');
      }
    } else {
      //console.log('Could not find square-placement element');
    }
  }
});


// PRODUCT CARD ADD ON MOBILE

document.addEventListener('click', function(e) {
    const trigger = e.target.closest('.product-add-trigger');
    
    if (trigger) {
        // Find the product card container first
        const productCard = trigger.closest('.product-card--root');
        
        if (productCard) {
            // Now find the product-card--add within that container OR in the body
            let targetCard = productCard.querySelector('.product-card--add');
            
            // If not found in the container, it might be in the body already
            if (!targetCard) {
                const productHandle = productCard.dataset.handle;
                if (productHandle) {
                    // Look for it in the body using a data attribute or class
                    targetCard = document.body.querySelector(`.product-card--add[data-product-handle="${productHandle}"]`);
                    
                    // If still not found, search by any unique identifier
                    if (!targetCard) {
                        // Fallback: find any card in body that belongs to this product
                        targetCard = Array.from(document.body.querySelectorAll('.product-card--add'))
                            .find(card => {
                                return card.querySelector(`[data-variant="46764484624612"]`);
                            });
                    }
                }
            }
            
            if (targetCard) {
                // Store product handle for future reference
                if (!targetCard.dataset.productHandle && productCard.dataset.handle) {
                    targetCard.dataset.productHandle = productCard.dataset.handle;
                }
                
                // Always move to body and activate (even if already there)
                document.body.appendChild(targetCard);
                targetCard.classList.add('active');
            }
        }
    } 
    // Handle closing when clicking outside
    else {
        const clickedInsideOptions = e.target.closest('.product-options--container');
        const clickedAddButton = e.target.closest('.product--add--button');
        
        // Don't close if clicking the add button - wait for cart event instead
        if (!clickedInsideOptions && !clickedAddButton) {
            const activeCards = document.querySelectorAll('.product-card--add.active');
            activeCards.forEach(card => {
                card.classList.remove('active');
            });
        }
    }
});

// Close cards when product is added to cart
window.addEventListener('theme:cart:productAdded', ({ detail: variantId }) => {
    const activeCards = document.querySelectorAll('.product-card--add.active');
    activeCards.forEach(card => {
        card.classList.remove('active');
    });
});


// CART COUNTER IN CART DRAWER

const sourceElement = document.querySelector('.header--root .header--cart');
const targetElement = document.querySelector('.drawer--cart-total');

if (sourceElement && targetElement) {
  // Create observer to watch for attribute changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-cart-count') {
        const newValue = sourceElement.getAttribute('data-cart-count');
        targetElement.setAttribute('data-cart-count', newValue);
      }
    });
  });

  // Start observing
  observer.observe(sourceElement, {
    attributes: true,
    attributeFilter: ['data-cart-count']
  });

  // Sync initial value
  const initialValue = sourceElement.getAttribute('data-cart-count');
  if (initialValue !== null) {
    targetElement.setAttribute('data-cart-count', initialValue);
  }
}


// CART MINUS AT QTY 1 -> REMOVE ITEM
// The theme's minus button does nothing at qty 1, so trigger the remove button instead.
// Capture phase so we read the value before the theme's own handler runs.

function cartMinusRemove(e) {
  if (e.type === 'keydown' && e.key !== 'Enter') return;

  const minus = e.target.closest('quantity-selector[data-type="cart"] .quantity-selector--minus');
  if (!minus) return;

  const selector = minus.closest('quantity-selector');
  const input = selector.querySelector('.quantity-selector--input');
  const remove = selector.querySelector('.quantity-selector--remove');

  if (remove && parseInt(input.value) === 1) {
    e.preventDefault();
    e.stopPropagation();
    remove.click();
  }
}

document.addEventListener('click', cartMinusRemove, true);
document.addEventListener('keydown', cartMinusRemove, true);


// PDP RATING -> REVIEWS

document.addEventListener('click', (e) => {
  const link = e.target.closest('[data-scroll-to-reviews]');
  if (!link) return;

  const reviewsRow = document.getElementById('product-reviews');
  if (!reviewsRow) return;

  e.preventDefault();

  // Open the reviews row if it's collapsed
  const toggle = reviewsRow.querySelector('.collapsible-row--toggle');
  if (toggle && toggle.getAttribute('aria-expanded') !== 'true') {
    toggle.click();
  }

  reviewsRow.scrollIntoView({ behavior: 'smooth', block: 'start' });
});


// X-MENU MEGA HEIGHT
// Every mega menu panel gets the same height (the tallest). Measuring means showing the hidden
// panels, which forces a full-page layout, so:
// - all panels are measured in one batch (one layout, not one per panel), and
// - it runs when the browser is idle or on the first menu open, not while the page is loading.
// This replaces the theme's per-panel setNaturalHeights, which blocked the first paint.
function measureMegaMenuHeights(menu) {
  const panels = [...menu.menus];
  const shown = panels.filter(panel => panel.getAttribute('aria-hidden') === 'true');

  // Write: show every hidden panel invisibly
  shown.forEach(panel => {
    panel.style.visibility = 'hidden';
    panel.setAttribute('aria-hidden', 'false');
  });
  panels.forEach(panel => panel.style.setProperty('--height', 'auto'));

  // Read: one layout for all panels
  const tallest = Math.max(0, ...panels.map(panel => panel.offsetHeight));

  // Write: hide them again and apply the shared height
  shown.forEach(panel => {
    panel.setAttribute('aria-hidden', 'true');
    panel.style.visibility = '';
  });
  panels.forEach(panel => {
    panel.style.setProperty('--natural-height', `${tallest}px`);
    // An open panel keeps showing at full height; closed ones go back to the theme's default
    if (panel === menu.open_menu) panel.style.setProperty('--height', 'var(--natural-height)');
  });
}

customElements.whenDefined('x-menu-element').then(() => {
  const proto = customElements.get('x-menu-element').prototype;
  const idle = window.requestIdleCallback || (callback => setTimeout(callback, 1500));

  proto.ensureNaturalHeights = function() {
    if (!this.heights_dirty) return;
    this.heights_dirty = false;
    measureMegaMenuHeights(this);
  };

  // The theme calls this on load and when the width changes: just mark the heights stale
  proto.setNaturalHeights = function() {
    this.heights_dirty = true;
    idle(() => this.ensureNaturalHeights(), { timeout: 3000 });
  };

  // Make sure heights are ready before any menu opens (hover, focus or touch)
  const openMenu = proto.openMenu;
  proto.openMenu = function(...args) {
    this.ensureNaturalHeights();
    return openMenu.apply(this, args);
  };

  document.querySelectorAll('x-menu-element').forEach(menu => menu.setNaturalHeights());
});


// ===== X-MENU HOVER INTENT =====
// Replaces the theme's mouse handling for the desktop menu (keyboard and touch are unchanged):
// - opens on hover, fading in (custom.css)
// - switches between menus without closing and reopening; the new contents fade in
// - gives a short grace period when leaving, and fades out instead of snapping shut
const X_MENU_CLOSE_DELAY = 250;
const X_MENU_FADE_OUT = 150; // keep in sync with x-menu-fade-out in custom.css

function setupXMenuHoverIntent(menu) {
  const links = menu.menu_links;
  const panels = menu.menus;
  if (!links?.length) return;

  let closeTimer = null;
  let fadeTimer = null;

  // Dark page overlay, only for megamenus. It fades in and out with the panel (custom.css)
  const setOverlay = (panel) => {
    document.body.classList.toggle('menu-open', panel?.getAttribute('data-megamenu') === 'true');
  };

  const cancelTimers = () => {
    clearTimeout(closeTimer);
    closeTimer = null;
  };

  // Stop a fade-out in progress so the panel can be reused
  const cancelFadeOut = () => {
    clearTimeout(fadeTimer);
    fadeTimer = null;
    panels.forEach(panel => panel.removeAttribute('data-x-menu-closing'));
  };

  const open = (link) => {
    cancelTimers();
    cancelFadeOut();
    const panel = link.nextElementSibling;
    const current = menu.open_menu;
    if (current === panel) {
      // Back on a menu that was fading out: keep it, and bring the overlay back
      setOverlay(panel);
      return;
    }

    // Switching from one open menu to another: keep the panel in place and only swap its contents
    const switching = !!current;
    panel.toggleAttribute('data-x-menu-switch', switching);

    const bothMega = switching
      && current.getAttribute('data-megamenu') === 'true'
      && panel.getAttribute('data-megamenu') === 'true';
    menu.openMenu(link, bothMega);
    setOverlay(panel);
  };

  const close = () => {
    cancelTimers();
    const panel = menu.open_menu;
    if (!panel || fadeTimer) return;

    panel.setAttribute('data-x-menu-closing', '');
    setOverlay(null);
    fadeTimer = setTimeout(() => {
      fadeTimer = null;
      panel.removeAttribute('data-x-menu-closing');
      if (menu.open_menu === panel) menu.closeMenu(true);
    }, X_MENU_FADE_OUT);
  };

  const scheduleClose = () => {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, X_MENU_CLOSE_DELAY);
  };

  // Remove the theme's mouse listeners and use ours instead
  links.off('mouseenter.XMenu mouseleave.XMenu');
  panels.off('mouseenter.XMenu mouseleave.XMenu');

  links.forEach(link => {
    link.addEventListener('mouseenter', () => open(link), { passive: true });

    link.addEventListener('mouseleave', ({ relatedTarget }) => {
      // Moving down into this link's own panel keeps it open
      if (relatedTarget && link.nextElementSibling?.contains(relatedTarget)) return;
      scheduleClose();
    }, { passive: true });
  });

  panels.forEach(panel => {
    panel.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      closeTimer = null;
      if (fadeTimer && menu.open_menu === panel) {
        cancelFadeOut();
        setOverlay(panel);
      }
    }, { passive: true });

    panel.addEventListener('mouseleave', ({ relatedTarget }) => {
      // Moving back up to this panel's own link keeps it open
      if (relatedTarget && panel.previousElementSibling?.contains(relatedTarget)) return;
      scheduleClose();
    }, { passive: true });
  });
}

customElements.whenDefined('x-menu-element').then(() => {
  // Only for mouse users; touch devices keep the theme's tap behaviour
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  document.querySelectorAll('x-menu-element').forEach(setupXMenuHoverIntent);
});


// ===== FADE IN LAZY-LOADED IMAGES =====
// Lazy images that haven't loaded yet start hidden and fade in once they arrive.
// Images already loaded (above the fold, cached) are left alone. The classes are removed
// afterwards so the theme's own opacity rules (e.g. product card hover swap) take over again.
const LAZY_FADE_MS = 500; // keep in sync with .lazy-fade in custom.css

function fadeInLazyImage(img) {
  if (img.complete || img.dataset.lazyFade) return;
  // Theme images only: app widgets (e.g. a popup's 200+ country flags) render their own images
  if (!img.closest('.shopify-section')) return;
  // Product card hover images are already hidden until hover
  if (img.classList.contains('product-card--hover-image')) return;

  img.dataset.lazyFade = 'pending';
  img.classList.add('lazy-fade', 'lazy-fade--hidden');

  const reveal = () => {
    img.classList.remove('lazy-fade--hidden');
    setTimeout(() => img.classList.remove('lazy-fade'), LAZY_FADE_MS + 50);
  };
  img.addEventListener('load', reveal, { once: true });
  img.addEventListener('error', reveal, { once: true });
}

function fadeInLazyImages(root = document) {
  root.querySelectorAll?.('img[loading="lazy"]').forEach(fadeInLazyImage);
}

fadeInLazyImages();

// Images added later: filtering, infinite scroll, recommendations, carousels
new MutationObserver(mutations => {
  mutations.forEach(({ addedNodes }) => {
    addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      if (node.matches('img[loading="lazy"]')) fadeInLazyImage(node);
      else fadeInLazyImages(node);
    });
  });
}).observe(document.body, { childList: true, subtree: true });


// ===== SCROLL TO TOP ON FILTER CLICK =====
document.addEventListener('click', (e) => {
  const filterElement = e.target.closest('[data-filter], .filter-item, .facet-checkbox, input[type="checkbox"]');
  
  if (filterElement) {
    //console.log('Filter clicked, scrolling to top immediately');
    window.scrollTo(0, 0);
  }
});

// ===== UPDATE PRODUCT COUNT ON FILTER AND SEARCH =====
const originalFetch = window.fetch;
window.fetch = function(...args) {
  return originalFetch.apply(this, args).then(response => {
    const clonedResponse = response.clone();
    
    if (args[0] && typeof args[0] === 'string') {
      const url = args[0];
      
      // Check if this is a filter OR search request
      if (url.includes('filter') || url.includes('search') || url.includes('/search?')) {
        //console.log('Filter/Search request detected:', url);
        
        clonedResponse.text().then(html => {
          //console.log('Response received, parsing...');
          
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          const newCountElement = doc.querySelector('[data-products-count]');
          //console.log('New count element from response:', newCountElement);
          
          if (newCountElement) {
            const newCount = parseInt(newCountElement.dataset.productsCount);
            //console.log('New filtered count:', newCount);
            
            setTimeout(() => {
              displayProductCount(newCount);
            }, 150);
          } else {
            // Fallback: try to count product items in the response
            const productItems = doc.querySelectorAll('[data-product-id], .product-item, .product-card');
            if (productItems.length > 0) {
              displayProductCount(productItems.length);
            }
          }
        });
      }
    }
    
    return response;
  });
};

function displayProductCount(count) {
  //console.log('displayProductCount called with:', count);
  
  const countDisplay = document.querySelector('.collection-product-count');
  const countNumber = countDisplay?.querySelector('.count-number');
  
  if (countNumber && !isNaN(count)) {
    countNumber.textContent = count;
    //console.log('Updated count number to:', count);
  }
  
  if (countDisplay && !isNaN(count)) {
    countDisplay.dataset.productsCount = count;
  }
}

// ===== DYNAMIC FILTER HEIGHT =====
function updateFilterHeight() {
  const filterRoot = document.querySelector('.filter--root');
  
  if (!filterRoot) {
    //console.log('Filter root not found');
    return;
  }
  
  // Remove the height temporarily to get true content height
  filterRoot.style.height = 'auto';
  
  // Force reflow
  filterRoot.offsetHeight;
  
  // Get the actual content height
  const contentHeight = filterRoot.scrollHeight;
  
  // Set the height
  filterRoot.style.height = contentHeight + 'px';
  
  //console.log('Filter height updated to:', contentHeight + 'px');
}

// Watch for filter toggle clicks with proper timing
document.addEventListener('click', (e) => {
  const filterToggle = e.target.closest('.filter--toggle');
  
  if (filterToggle) {
  //  console.log('Filter toggle clicked');
    
    // Update immediately
    setTimeout(updateFilterHeight, 10);
    // Update after transition
    setTimeout(updateFilterHeight, 350);
  }
});

// Watch for attribute changes on filter menus (they likely get aria-expanded or data attributes)
const observeFilters = () => {
  const filterRoot = document.querySelector('.filter--root');
  
  if (!filterRoot) {
   // console.log('Filter root not found for observer');
    return;
  }
  
  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    
    mutations.forEach(mutation => {
      // Check if it's a class or attribute change on filter menus
      if (mutation.type === 'attributes' && 
          (mutation.target.classList.contains('filter--menu') || 
           mutation.target.classList.contains('filter--toggle'))) {
        shouldUpdate = true;
      }
    });
    
    if (shouldUpdate) {
     // console.log('Filter state changed, updating height');
      updateFilterHeight();
    }
  });
  
  observer.observe(filterRoot, {
    attributes: true,
    subtree: true,
    attributeFilter: ['aria-expanded', 'data-transition-active', 'class', 'style']
  });
  
 // console.log('Filter observer initialized');
};

// ===== INITIALIZE ON PAGE LOAD =====
document.addEventListener('DOMContentLoaded', () => {
 // console.log('DOMContentLoaded fired');
  
  const countElement = document.querySelector('[data-products-count]');
  if (countElement) {
    const totalCount = parseInt(countElement.dataset.productsCount);
  //  console.log('Initial total count:', totalCount);
    displayProductCount(totalCount);
  }
  
  setTimeout(() => {
    updateFilterHeight();
    observeFilters();
  }, 500);
});

window.addEventListener('theme:navigation:reloaded', () => {
  setTimeout(updateFilterHeight, 100);
});





// SORT BY CLONE SYNC
document.addEventListener('change', (e) => {
  // Check if the change event is from the clone filter
  if (e.target.matches('#sort_filter-clone input[type="radio"]')) {
    const selectedValue = e.target.value;
    
    // Find the main filter wherever it is
    const mainFilter = document.getElementById('sort_filter');
    if (mainFilter) {
      const mainRadio = mainFilter.querySelector(`input[value="${selectedValue}"]`);
      if (mainRadio) {
        const mainLabel = mainFilter.querySelector(`label[for="${mainRadio.id}"]`);
        if (mainLabel) {
          mainLabel.click();
        }
      }
    }
  }
});

// SHARED ELEMENTS
const collectionSubheader = document.querySelector('.collection-subheader');

// FILTERS BUTTON - Opens main filters
const filterBtn = document.querySelector('.btn-filters');
const filterToggleMenu = document.querySelector('.main-collection--filters');

if (filterBtn && filterToggleMenu) {
  filterBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    
    // Close the sort menu if it's open
    const sortFiltersElement = document.querySelector('.sort-filters');
    const sortBtn = document.querySelector('.btn-sort');
    if (sortFiltersElement) {
      sortFiltersElement.classList.remove('show');
    }
    if (sortBtn) {
      sortBtn.classList.remove('active');
    }
    
    // Toggle the main filters visibility
    filterToggleMenu.classList.toggle('show');
    
    // Toggle active class on button
    filterBtn.classList.toggle('active');
    
    // Toggle body scroll lock
    if (filterToggleMenu.classList.contains('show')) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    // Instant anchor to collection-subheader with sticky header offset
    if (collectionSubheader) {
      const headerOffset = 90;
      const elementPosition = collectionSubheader.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'auto'
      });
    }
  });
}

// SORT BUTTON - Opens sort filters
const sortBtn = document.querySelector('.btn-sort');
const sortFiltersElement = document.querySelector('.sort-filters');

if (sortBtn && sortFiltersElement) {
  sortBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    
    // Close the main filters if open
    if (filterToggleMenu) {
      filterToggleMenu.classList.remove('show');
    }
    if (filterBtn) {
      filterBtn.classList.remove('active');
    }
    
    // Toggle sort filters
    sortFiltersElement.classList.toggle('show');
    
    // Toggle active class on button
    sortBtn.classList.toggle('active');
    
    // Toggle body scroll lock
    if (sortFiltersElement.classList.contains('show')) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    // Instant anchor to collection-subheader with sticky header offset
    if (collectionSubheader) {
      const headerOffset = 90;
      const elementPosition = collectionSubheader.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'auto'
      });
    }
  });
}

// CLOSE ON OUTSIDE CLICK - Combined for both menus
document.addEventListener('click', (e) => {
  // Close sort menu if clicking outside
  if (sortFiltersElement && sortBtn) {
    if (!sortFiltersElement.contains(e.target) && !sortBtn.contains(e.target)) {
      sortFiltersElement.classList.remove('show');
      sortBtn.classList.remove('active');
    }
  }
  
  // Close filter menu if clicking outside
  if (filterToggleMenu && filterBtn) {
    if (!filterToggleMenu.contains(e.target) && !filterBtn.contains(e.target)) {
      filterToggleMenu.classList.remove('show');
      filterBtn.classList.remove('active');
    }
  }
  
  // Reset body scroll if both menus are closed
  if (!document.querySelector('.sort-filters.show') && !document.querySelector('.main-collection--filters.show')) {
    document.body.style.overflow = '';
  }
});

// Prevent clicks inside menus from closing them
if (sortFiltersElement) {
  sortFiltersElement.addEventListener('click', (e) => {
    e.stopPropagation();
  });
}

if (filterToggleMenu) {
  filterToggleMenu.addEventListener('click', (e) => {
    e.stopPropagation();
  });
}






window.addEventListener('theme:cart:updated', ({ detail: cart }) => {
  setTimeout(() => {
    checkSectionConditionsAndUpdate();
  }, 1000 * 2);
});

const renderContents = (parsedState, sectionsToRender) => {
    sectionsToRender.forEach((section) => {
    // get the element present in current DOM to update
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);
    if (parsedState[section.id])
      // get the innerHTML of fetched updated element based on id and selector
      sectionElement.innerHTML = getSectionInnerHTML(
        parsedState[section.id],
      section.selector
    );
  });
};

const getSectionInnerHTML = (html, selector) =>
  // parses string to HTML
  new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector(
      selector.slice(0, 1) === "#" && !selector.includes("shopify-section")
        ? `#shopify-section-${selector.slice(1)}`
        : selector
    ).innerHTML;


// checks for all the length of sections to fetch and update
// because max length which API can fetch is 5 only
const checkSectionConditionsAndUpdate = () => {

  const sectionsConfig = getCartDrawerSectionsToRender()


  getSectionsAndUpdate(sectionsConfig);
};

// fetches the sections and updates them accordingly
const getSectionsAndUpdate = async (sectionsConfig) => {
  // concatenates sections IDs to a string
  const sectionsToFetch = sectionsConfig
    .flat()
    .map((section) => section.id)
    .join(",");

  const sectionData = await fetch(
    `${window.location.pathname}?sections=${sectionsToFetch}`
  );
  const data = await sectionData.json();
  
  renderContents(data, sectionsConfig);
};
    
const getCartDrawerSectionsToRender = () => {
  return [
    {
      id: "cart-drawer",
      selector: `cart-element.cart--root[data-view="drawer"]`,
    },
    {
      id: "cart",
      selector: `cart-element.cart--root[data-view="desktop"]`,
    },
  ];
};


// DEFAULT PREDICTIVE SEARCH

document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.querySelector('.search--textbox');
  const predictiveSearch = document.querySelector('.predictive-search-default');
  
  if (searchInput && predictiveSearch) {
    searchInput.addEventListener('focus', function() {
      predictiveSearch.classList.add('active');
    });
    
    // Prevent mousedown on predictive search from triggering blur
    predictiveSearch.addEventListener('mousedown', function(e) {
      e.preventDefault();
    });
    
    searchInput.addEventListener('blur', function() {
      setTimeout(function() {
        predictiveSearch.classList.remove('active');
      }, 100);
    });
  }
});


// COLLECTION SUB HEADER STICKY / IS STUCK

const stickyElement = document.querySelector('.section--collection-subheader');

if (stickyElement) {
  // Get the original position of the element
  const stickyTop = stickyElement.offsetTop;
  
  function checkSticky() {
    if (window.scrollY >= stickyTop) {
      stickyElement.classList.add('is-stuck');
    } else {
      stickyElement.classList.remove('is-stuck');
    }
  }
  
  // Check on scroll
  window.addEventListener('scroll', checkSticky);
  
  // Check initially
  checkSticky();
}


// FIX BODY WHEN DRAWERS ARE OPEN


// Select the viewport element
const viewport = document.querySelector('.layout--viewport');
let scrollPosition = 0;

// Create a MutationObserver to watch for attribute changes
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.attributeName === 'data-drawer-status') {
      const status = viewport.getAttribute('data-drawer-status');
      
      if (status === 'opened') {
        // Store current scroll position
        scrollPosition = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollPosition}px`;
        document.body.style.width = '100%';
      } else {
        // Restore scroll position
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollPosition);
      }
    }
  });
});

// Start observing
observer.observe(viewport, { attributes: true });


// APPLY BUTTON - Close the main filters
const applyButton = document.querySelector('button[data-type="apply"]');
if (applyButton) {
  applyButton.addEventListener('click', function() {
    // Remove show class from main filters
    const mainFilters = document.querySelector('.main-collection--filters');
    if (mainFilters) {
      mainFilters.classList.remove('show');
    }
    
    // Also remove active class from filter button
    const filterBtn = document.querySelector('.btn-filters');
    if (filterBtn) {
      filterBtn.classList.remove('active');
    }
    
    // Restore body scroll
    document.body.style.overflow = '';
  });
}

// ===== OPEN CART DRAWER IMMEDIATELY ON ADD TO CART =====
// The theme only opens the drawer after /cart/add.js responds and the new drawer HTML
// is swapped in. Open it straight away in a loading state instead, show the product
// being added as a pending line item, and swap in the real cart when the response arrives.
const productJsonCache = new Map();

function fetchProductJson(handle) {
  if (!productJsonCache.has(handle)) {
    const request = fetch(`/products/${handle}.js`)
      .then(response => (response.ok ? response.json() : null))
      .catch(() => null);
    productJsonCache.set(handle, request);
  }
  return productJsonCache.get(handle);
}

function getAddedVariantId(options) {
  const body = options.body;
  if (typeof body !== 'string') return null;

  try {
    const data = JSON.parse(body);
    return String(data.items?.[0]?.id ?? data.id ?? '');
  } catch {
    return new URLSearchParams(body).get('id');
  }
}

function formatPrice(cents) {
  const currency = window.Shopify?.currency?.active || 'AUD';
  return new Intl.NumberFormat('en-AU', { style: 'currency', currency }).format(cents / 100);
}

function buildPendingItem(product, variant) {
  const imageSrc = variant.featured_image?.src || product.featured_image;
  const element = (tag, className, text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text) el.textContent = text;
    return el;
  };

  // Not data-variant-id: the theme copies images between rows matching that attribute
  const item = element('div', 'cart--item cart--item--pending');
  item.dataset.pendingVariantId = variant.id;

  const image = element('div', 'cart--item--image');
  if (imageSrc) {
    const url = new URL(imageSrc, window.location.origin);
    url.searchParams.set('width', '300');
    const img = element('img');
    img.src = url.toString();
    img.alt = product.title;
    image.append(img);
  }

  const info = element('div', 'cart--item--info');
  const title = element('div', 'cart--item--title');
  title.append(element('div', 'h7', product.vendor));
  const name = element('div', 'b1', product.title);
  name.dataset.item = 'block-heading';
  title.append(name);
  info.append(title);
  if (!product.has_only_default_variant && variant.public_title) {
    const variantName = element('div', 'cart--item--variant-name h7', variant.public_title);
    variantName.dataset.item = 'nav-text';
    info.append(variantName);
  }

  // Same markup as the line item's remove button, reading "Adding" until Shopify confirms
  const actions = element('div', 'cart--item-actions');
  const quantity = element('div', 'cart--item--quantity');
  const selector = element('div', 'quantity-selector--root');
  const adding = element('button', 'quantity-selector--remove quantity-selector--adding');
  adding.type = 'button';
  adding.disabled = true;
  const spinner = element('span', 'cart--total-spinner');
  spinner.setAttribute('aria-hidden', 'true');
  adding.append(spinner, element('span', 'h6 text-uppercase', 'Adding'));
  selector.append(adding);
  quantity.append(selector);
  actions.append(quantity);

  const price = element('div', 'cart--item--price');
  const total = element('div', 'cart--item--total money h5', formatPrice(variant.price));
  total.dataset.item = 'nav-text';
  price.append(total);
  actions.append(price);

  item.append(image, info, actions);
  return item;
}

async function showPendingItem(drawerCart, trigger, variantId, isStillAdding) {
  const handle = trigger.closest('[data-handle]')?.dataset.handle
    || window.location.pathname.match(/\/products\/([^/?#]+)/)?.[1];
  if (!drawerCart || !handle || !variantId) return;

  // Already in the cart: Shopify increases that line's quantity, so just highlight it
  const existing = drawerCart.querySelector(`.cart--item[data-variant-id="${variantId}"]`);
  if (existing) existing.classList.add('cart--item--pending');

  const product = await fetchProductJson(handle);
  const variant = product?.variants.find(v => String(v.id) === variantId);
  if (!variant || !isStillAdding()) return;

  showEstimatedTotal(drawerCart, variant.price);

  // Shopify adds new lines to the top of the cart
  const body = drawerCart.querySelector('.cart--body');
  if (!existing && body) body.prepend(buildPendingItem(product, variant));
}

// Show the subtotal including the item being added. It's an estimate (discounts and
// samples aren't known yet), so it shows a spinner until the real cart HTML replaces it.
function showEstimatedTotal(drawerCart, addedCents) {
  const total = drawerCart.querySelector('.cart--total-price[data-total-cents]');
  const amount = total?.querySelector('.cart--total-amount');
  const currentCents = parseInt(total?.dataset.totalCents, 10);
  if (!amount || isNaN(currentCents)) return;

  const estimate = ((currentCents + addedCents) / 100).toLocaleString('en-AU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  // Keep the store's money format (e.g. "$123.00 AUD") and only swap the number
  amount.dataset.confirmedText ??= amount.textContent;
  amount.textContent = amount.textContent.replace(/\d[\d,]*\.\d{2}/, estimate);
}

customElements.whenDefined('cart-element').then(() => {
  const CartElement = customElements.get('cart-element');
  const originalAddItems = CartElement.addItems;
  const viewport = document.querySelector('.layout--viewport');

  CartElement.addItems = async function(options = {}, trigger = false) {
    // No trigger means the theme isn't using the drawer for this add
    if (!trigger) return originalAddItems.call(this, options, trigger);

    const drawerCart = document.querySelector('cart-element[data-view="drawer"]');
    const wasEmpty = viewport?.getAttribute('data-cart-empty');
    let adding = true;

    drawerCart?.setAttribute('data-updating', 'true');
    viewport?.setAttribute('data-cart-empty', 'false');
    window.trigger('theme:drawer:open', { side: 'right', view: 'cart-drawer', trigger });
    showPendingItem(drawerCart, trigger, getAddedVariantId(options), () => adding);

    try {
      // Drawer is already open, so don't let the theme open it again after the update
      await originalAddItems.call(this, options, false);
    } catch (error) {
      if (wasEmpty !== null) viewport?.setAttribute('data-cart-empty', wasEmpty);
      // The add failed, so put the confirmed subtotal back
      const amount = drawerCart?.querySelector('.cart--total-amount[data-confirmed-text]');
      if (amount) amount.textContent = amount.dataset.confirmedText;
      window.trigger('theme:drawer:close');
      throw error;
    } finally {
      adding = false;
      drawerCart?.removeAttribute('data-updating');
      drawerCart?.querySelectorAll('.cart--item--pending').forEach(item => {
        // The theme swaps in fresh line items on success; remove our placeholder if it's still there
        if (!item.dataset.lineNum) item.remove();
        else item.classList.remove('cart--item--pending');
      });
    }
  };
});

// Start loading product data when a shopper shows intent to add, so the pending
// line item can appear in the drawer straight away
document.addEventListener('pointerover', (event) => {
  const button = event.target.closest?.('.product--add--button button, .product-card--add button.add, .product-buy-buttons--primary, .product-add-trigger');
  const handle = button?.closest('[data-handle]')?.dataset.handle;
  if (handle) fetchProductJson(handle);
}, { passive: true });
